import { createFileRoute } from "@tanstack/react-router";

import { CoachAutomationPage } from "src/pages/CoachAutomationPage";

export const Route = createFileRoute(
  "/_auth/_coach/automations/$automationId/",
)({
  component: CoachAutomationPage,
  ssr: true,
});
